
import { Component } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-reset-password',
    standalone: true,
    imports: [RouterModule, ReactiveFormsModule, TranslateModule],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {
    token?: string;
    public resetForm!: FormGroup;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private toaster: ToastrService,
        private authService: AuthService,
        private translationService: TranslationService
    ) {
        this.resetForm = this.fb.group({
            newPassword: ['', [Validators.required]],
        });
    }

    ngOnInit() {
        this.route.params.subscribe((params: Params) => {
            this.token = params['token'];
        });
    }

    async onSubmit() {
        if (this.token === undefined || !this.resetForm.valid) {
            return;
        }

        const password = this.resetForm.value.newPassword;

        try {
            let response = await firstValueFrom(
                this.authService.resetPassword(this.token, password)
            );

            const successMessage = this.translationService.instant(
                'common.messages.operationSuccess'
            );
            this.toaster.success(successMessage);
            this.router.navigate(['/login']);
        } catch (error) {
            const errorMessage = this.translationService.instant(
                'errors.network.serverError'
            );
            const errorTitle = this.translationService.instant(
                'common.labels.error'
            );
            this.toaster.error(errorMessage, errorTitle);
        }
    }
}
